import { defineMessages } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';

const messages = defineMessages({
  title: { id: 'Homepage alert', defaultMessage: 'Homepage alert' },
  text: { id: 'Alert text', defaultMessage: 'Alert text' },
  href: { id: 'Link', defaultMessage: 'Link' },
  hrefOptional: { id: 'Optional', defaultMessage: 'Optional' },
  openInNewTab: {
    id: 'Open link in new tab',
    defaultMessage: 'Open link in new tab',
  },
});

export const HomepageAlertSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['text', 'href', 'openInNewTab'],
    },
  ],
  properties: {
    text: {
      title: intl.formatMessage(messages.text),
      widget: 'textarea',
    },
    href: {
      title: intl.formatMessage(messages.href),
      widget: 'text',
      description: intl.formatMessage(messages.hrefOptional),
    },
    openInNewTab: {
      title: intl.formatMessage(messages.openInNewTab),
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export const getHomepageAlertSchemaForData = ({ intl, formData }) => {
  const schema = HomepageAlertSchema({ intl });
  const link = (formData?.href || '').trim();

  if (link) {
    return schema;
  }

  const mutated = cloneDeep(schema);
  mutated.fieldsets[0].fields = ['text', 'href'];
  return mutated;
};
